<div class="search-dym mt-3 mt-md-0" *ngIf="searchResult?.searchDym?.dymActive">
  <div class="container search-dym-main-container g-0">
    <div class="row">
      <div class="col search-dym-ac-container">
          <span class="search-dym-showing">
            {{ (shouldShowInstead() ? 'didYouMeanPatternP1' : 'didyoumean') | translate }}
            <a (click)="handleClick('suggested')"
               class="search-dym-showing-key"
               [innerHTML]="searchResult?.searchDym?.suggestedTerm"></a>{{ 'didYouMeanPatternP2' | translate }}
          </span>
        <span class="search-dym-instead" *ngIf="shouldShowInstead()">
            {{ 'didYouMeanPatternP3' | translate }}
          <a (click)="handleClick('original')"
             class="search-dym-instead-key"
             [innerHTML]="searchResult?.searchDym?.originalTerm"></a>{{ 'didYouMeanPatternP4' | translate }}
          </span>
      </div>
    </div>
  </div>
</div>
